export default "__VITE_ASSET__BzB8K4Wf__"